export function clamp(number, lower, upper) {
  const max = upper || lower;
  const min = lower || 0;

  return Math.min(Math.max(number, min), max);
}

export function swap(array, moveIndex, toIndex) {
  const item = array[moveIndex];
  const length = array.length;
  const diff = moveIndex - toIndex;

  if (diff > 0) {
    return [
      ...array.slice(0, toIndex),
      item,
      ...array.slice(toIndex, moveIndex),
      ...array.slice(moveIndex + 1, length),
    ];
  }

  if (diff < 0) {
    const targetIndex = toIndex + 1;

    return [
      ...array.slice(0, moveIndex),
      ...array.slice(moveIndex + 1, targetIndex),
      item,
      ...array.slice(targetIndex, length),
    ];
  }

  return array;
}
